export var DrawerMode;
(function (DrawerMode) {
    DrawerMode["COPY_PINBOARD_ITEMS"] = "COPY_PINBOARD_ITEMS";
    DrawerMode["CREATE_PINBOARD"] = "CREATE_PINBOARD";
    DrawerMode["CREATE_PINBOARD_ITEM"] = "CREATE_PINBOARD_ITEM";
    DrawerMode["DELETE_PINBOARD"] = "DELETE_PINBOARD";
    DrawerMode["MANAGE_PINBOARD"] = "MANAGE_PINBOARD";
    DrawerMode["MOVE_PINBOARD_ITEMS"] = "MOVE_PINBOARD_ITEMS";
    DrawerMode["RENAME_PINBOARD"] = "RENAME_PINBOARD";
    DrawerMode["DELETE_PIN"] = "DELETE_PIN";
})(DrawerMode || (DrawerMode = {}));
